export const SET_MOUSE_POSITION = 'SET_MOUSE_POSITION'
export const SET_SCROLL_TOP = 'SET_SCROLL_TOP'
export const SET_GLOBAL_DATA = 'SET_GLOBAL_DATA'
export const SET_ANGLE = 'SET_ANGLE'
